import { Typography, Stack, FormLabel } from '@mui/material'
import { GetStepUpProviderRequest } from 'pbts/c1/api/stepup/v1/stepup'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { getStepUpProviderApi } from 'redux_toolkit/step-up-providers'
import { getProviderUrl } from './StepUpProviderDisplay'

type StepUpProviderTooltipContentProps = {
    providerId: string
}

export const StepUpProviderTooltipContent: FC<StepUpProviderTooltipContentProps> = ({ providerId }) => {
    const { data: response, isLoading } = getStepUpProviderApi.useGet(
        GetStepUpProviderRequest.create({
            id: providerId,
        }),
        { notify: false },
    )

    if (isLoading || !response?.stepUpProvider) {
        return null
    }

    const provider = response.stepUpProvider

    return <Stack spacing={1}>
        <Stack direction="row" spacing={1} alignItems="center">
            <FormLabel sx={{ color: 'inherit' }}>
                <FormattedMessage id="step_up_provider_display_name_label" defaultMessage="Name:" />
            </FormLabel>
            <Typography>{provider.displayName}</Typography>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
            <FormLabel sx={{ color: 'inherit' }}>
                <FormattedMessage id="step_up_provider_type_label" defaultMessage="Provider type:" />
            </FormLabel>
            <Typography>{provider.settings.oneofKind}</Typography>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
            <FormLabel sx={{ color: 'inherit' }}>
                <FormattedMessage id="step_up_provider_issuer_url_label" defaultMessage="Issuer URL:" />
            </FormLabel>
            <Typography>{getProviderUrl(provider)}</Typography>
        </Stack>
    </Stack>
}
